import { Controller } from "@hotwired/stimulus"

// Loads the <iframe>s inside a Bootstrap modal only when the modal first
// opens. Used for the WBM PDF: the document may be 100 MB and must not be
// fetched with every page view. loading="lazy" is not enough — Chrome loads
// hidden (display: none) lazy iframes eagerly — so the URL waits in data-src
// until the dialog is actually shown. Bootstrap's event name carries dots,
// which a Stimulus action descriptor would misread as a key filter, hence
// the manual listener.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.load = this.load.bind(this)
    this.element.addEventListener("show.bs.modal", this.load)
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.load)
  }

  load() {
    this.frameTargets.forEach((frame) => {
      if (!frame.getAttribute("src") && frame.dataset.src) frame.src = frame.dataset.src
    })
  }
}
